import clientInfo from 'common/lib/clientInfo';

export const STORAGE_EXPIRATION_HOURS = 24;
export const STORAGE_KEY = 'kjb_copyMagic_conversationAssistant'.concat(
  '_userId',
  clientInfo.get('user_id'),
  '_messages',
);
